import { Navigate, Outlet, useLocation } from 'react-router-dom';
import AuthLoader from './AuthLoader';
import { useAuth } from './useAuth';

/**
 * The gate in front of every signed-in page.
 *
 * <p>
 * Three states. While the session is being checked, the loader — never the page, so nothing
 * protected flashes before the answer. Signed in means a profile the server returned for this
 * session, not a token sitting in storage. Anything else goes to the login page, carrying where
 * they were (to come back to) and why the session ended (for the notice there).
 * </p>
 */
export default function ProtectedRoute() {
  const { isAuthenticated, initializing, endReason } = useAuth();
  const location = useLocation();

  if (initializing) return <AuthLoader />;

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location, ended: endReason }} />;
  }

  return <Outlet />;
}
